export interface DiagramVersion {
  id: string;
  title: string;
  mapName: string;
  diagramId: string;
  levelNumber: number;
  spaceId: string;
}

export interface DiagramVersionJSON extends DiagramVersion {
  team: {
    id: string;
  };
}

export const DIAGRAM_VERSION_STATES = {
  DRAFT: 'draft',
  BEING_AUTHORISED: 'being_authorised',
  READY: 'ready',
  MASTER: 'master',
  ARCHIVE: 'archive',
  NEVER_PUBLISHED: 'never_published',
  CANCELLED: 'cancelled'
} as const;

export type DiagramVersionState =
  (typeof DIAGRAM_VERSION_STATES)[keyof typeof DIAGRAM_VERSION_STATES];
